import { Component, inject } from "@angular/core"
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar"
import { MatIcon } from "@angular/material/icon"
import { ToastMessage } from "src/app/services/toast.service"

const SEVERITY_ICONS: Record<string, string> = {
    success: "check_circle",
    error: "error",
    info: "info",
    warning: "warning",
}

@Component({
    selector: "valben-toast",
    standalone: true,
    imports: [MatIcon],
    template: `
        <div class="valben-toast valben-toast-{{ severity }}">
            <mat-icon class="valben-toast-icon">{{ icon }}</mat-icon>
            <div class="valben-toast-content">
                @if (summary) {
                    <div class="valben-toast-summary">{{ summary }}</div>
                }
                @if (detail) {
                    <div class="valben-toast-detail">{{ detail }}</div>
                }
            </div>
            <button type="button" class="valben-toast-close" (click)="dismiss()" aria-label="Zatvori">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    `,
})
export class ToastComponent {
    private readonly _snackBarRef = inject(MatSnackBarRef)
    private readonly _data = inject<ToastMessage>(MAT_SNACK_BAR_DATA)

    readonly severity = this._data.severity === "warn" ? "warning" : (this._data.severity ?? "info")
    readonly icon = SEVERITY_ICONS[this.severity] ?? "info"
    readonly summary: string
    readonly detail: string

    constructor() {
        const summary = this._data.summary ?? ""
        const detail = this._data.detail ?? ""

        if (summary && detail && summary !== detail) {
            this.summary = summary
            this.detail = detail
        } else {
            this.summary = summary || detail
            this.detail = ""
        }
    }

    dismiss(): void {
        this._snackBarRef.dismiss()
    }
}
